import { observer } from "mobx-react-lite";
import PersonalScoreboardView from "../views/personalScoreboardView";

const PersonalScoreboardPresenter = observer(
    function PersonalScoreboardRender(props) {
        return (
            <PersonalScoreboardView
                personalScores={props.model.PersonalLeaderboardPromiseState}
                username={props.username}
            />
        )
    }
);

export { PersonalScoreboardPresenter };
